export const isMobile = () => {
    const ua = navigator.userAgent.toLowerCase()
    console.log("获取当前设备" + ua)
    return /mobile|android|iphone|ipad/i.test(ua)
}